import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Printer, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/common";
import { Result } from "@/components/NirogyamAI";
import { FullLoader } from "@/context/AuthContext";
import { fmtDate, useApi } from "@/lib/api";

export default function SharedAI() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const { data, loading, error } = useApi(`/shared/ai/${token}`);
  useEffect(() => { if (data && params.get("print") === "1") setTimeout(() => window.print(), 600); }, [data, params]);
  if (loading && !data) return <FullLoader />;
  return (
    <div className="min-h-screen bg-[#F7F9FA] print:bg-white">
      <header className="bg-white border-b border-[#E2E8ED] print:border-b-2">
        <div className="mx-auto max-w-3xl px-5 h-16 flex items-center justify-between"><Logo className="h-9" />
          {data && <Button size="sm" className="rounded-full no-print" onClick={() => window.print()} data-testid="shared-ai-print"><Printer className="h-4 w-4 mr-2" />Print / Save as PDF</Button>}</div>
      </header>
      <main className="mx-auto max-w-3xl px-5 py-8">
        {error ? <div className="surface p-10 text-center" data-testid="shared-ai-error"><p className="font-semibold">Link unavailable</p><p className="text-sm muted mt-2">{error}</p></div> : (
          <div className="surface p-6 sm:p-8 print:border-0 print:shadow-none" data-testid="shared-ai-page">
            <p className="flex items-center gap-2 text-sm font-semibold text-[#2412B5]"><Sparkles className="h-4 w-4" />Nirogyam AI · Report in simple words</p>
            <p className="mt-1 text-xs muted" data-testid="shared-ai-meta">Shared by {data.patient_first_name}{data.patient_code && ` (Patient ID ${data.patient_code})`} · Uploaded {fmtDate(data.uploaded_at)} · Link valid till {fmtDate(data.expires_at)}</p>
            <div className="mt-6"><Result r={data} lang={data.lang} shared /></div>
          </div>)}
        <p className="mt-6 text-center text-xs muted">Nirogyam Teleclinic · Nirogyam Diagnostics and Healthcare Pvt Ltd, Bhubaneswar · info@nirogyam.net · +91 7815007513</p>
      </main>
    </div>
  );
}
